import React, { useState } from 'react';
import cc from 'classcat';

// Small icon button that copies `value` to the clipboard and briefly shows a check.
const CopyButton = ({ value, className, title = 'Copy to clipboard' }) => {
    const [copied, setCopied] = useState(false);

    const onCopy = e => {
        // Don't trigger row/card click handlers the button may be nested in.
        e.stopPropagation();
        e.preventDefault();
        if (!value || !navigator.clipboard) {
            return;
        }
        navigator.clipboard.writeText(String(value)).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        });
    };

    return (
        <button type="button" className={cc(['copy-button', className])} onClick={onCopy} title={title} aria-label={title}>
            <i className={`fa-regular ${copied ? 'fa-circle-check' : 'fa-copy'}`} />
        </button>
    );
};

export default CopyButton;
